<script setup>
// 定义页面元数据
definePageMeta({
	ssr: true,
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "square.breadcrumb",
});

// 设置页面SEO信息
useHead({
	title: "心靈療愈冥想玄學塔羅星盤占卜知識聚集廣場",
	meta: [
		{
			name: "description",
			content:
				"先知命局擁有專業算命命理知識聚集廣場，為您提供豐富、專業、有趣的命理內容。無論是專業玄學文章視頻課程，還是專業命理學術教學，應有盡有",
		},
		{
			name: "keywords",
			content:
				"先知命局擁有專業算命命理知識聚集廣場，為您提供豐富、專業、有趣的命理內容。無論是專業玄學文章視頻課程，還是專業命理學術教學，應有盡有",
		},
	],
});

const { $isMobile } = useNuxtApp();

// 动态导入组件（代码分割）
const Component = $isMobile
	? defineAsyncComponent(() => import("@variants/seer/square/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/square/pc/index.vue"));
</script>

<template>
	<Component />
</template>
